export default {
    state: {
        loginRedirect: null,
    },
    mutations: {
        setLoginRedirect(state, loginRedirect) {
            state.loginRedirect = loginRedirect;
        }
    },
    getters: {
        getLoginRedirect(state) {
            if (!state.loginRedirect)
                return '/';

            return state.loginRedirect;
        }
    },
    actions: {
        getPackageStatus(context, {access_key, invoice_id}) {
            return this._vm.axios.get('user/package_status', {params: {access_key: access_key, invoice_id: invoice_id}})
        },
        getProductStatuses(context, {product_ids}) {
            return this._vm.axios.post('user/product_status', {product_ids: product_ids})
        }
    }
}
